const CostM = [
    { id: "0", value: "融資" },
    { id: "1", value: "外資" },
    { id: "2", value: "投信" },
];

export default CostM  